import UndoIcon from '@atlaskit/icon/core/undo';
import * as React from 'react';

export function SvgUndo() {
  return <UndoIcon label="" testId="ads-refreshed-icon" />;
}
